export default "__VITE_ASSET__CioqOhiN__"